module.exports = __webpack_public_path__ + "img/no-data.97e08d73.png";